export const theme = {
  fontSizes: {
    xxs: '1rem',
    xs: '1.2rem',
    sm: '1.4rem',
    md: '1.6rem',
    lg: '1.8rem',
    xl: '2rem',
    xxl: '2.4rem',
    xxxl: '2.6rem'
  },
  borderRadius: {
    50: '.4rem',
    100: '2.2rem',
    200: '2.4rem',
    300: '10rem'
  },
  colors: {
    white: '#ffffff',
    black: '#000000',
    lightBrown: '#ccad8a',
    brown: '#ba8d5b',
    brown50: '#a77946',
    brown75: '#81755C',
    cream: '#f1ece7',
    cream50: '#f8f4ef',
    orange: '#ff9900',
    lightPink: '#ffe0e0',
    red: '#ff1f1f',
    green: '#7ad111',
    lightSeaGreen: '#c3e0a0',
    seaGreen: '#A6cd78',
    gray: '#a6a6a6',
    gray50: '#f9f9f9',
    gray100: '#f8f7f5',
    gray200: '#f2f0ed',
    gray300: '#f1f0ee',
    gray400: '#e5e0d4'
  },
  devices: {
    desktop: '',
    tablet: '',
    phone: '1024px'
  },
  up: (breakpoint, vertical = false) =>
    `@media (min-${
      vertical ? 'height' : 'width'
    }: calc(${breakpoint} + 0.02px))`,
  down: (breakpoint, vertical = false) =>
    `@media (max-${vertical ? 'height' : 'width'}: ${breakpoint})`,
  between: (breakpointMin, breakpointMax, vertical = false) =>
    `@media (max-${vertical ? 'height' : 'width'}: ${breakpointMax}) and (min-${
      vertical ? 'height' : 'width'
    }: calc(${breakpointMin} + 0.02px))`
};
